import _ from 'lodash';

const getMemberIdentifier = memberId => {
  if (!memberId) {
    return null;
  }

  return memberId.userId ?? memberId.UserId ?? null;
};

export const resolveTypingMemberNickname = ({ memberId, nicknamesById, currentUserId }) => {
  const userId = getMemberIdentifier(memberId);

  if (!userId || userId === currentUserId) {
    return null;
  }

  return _.get(nicknamesById, userId, null);
};

export const getTypingLabel = nicknames => {
  switch (nicknames.length) {
    case 0:
      return '';
    case 1:
      return `${nicknames[0]} is typing...`;
    case 2:
      return `${nicknames[0]} and ${nicknames[1]} are typing...`;
    default:
      return 'Several people are typing...';
  }
};
